module.exports = __webpack_public_path__ + "icon-chat.png?d40ee1dc08c9952bf63ffe1a0629991f";


//////////////////
// WEBPACK FOOTER
// ./img/landing_v2/icon-chat.png
// module id = 70
// module chunks = 0